import React from 'react';

function ConditionsGeneralesDeVente() {
    return (
        <div>CGV</div>
    );
}

export default ConditionsGeneralesDeVente;
